/* eslint-disable @typescript-eslint/camelcase */
import it from './it_IT';
import en from './en_EN';
import es from './es_ES';

export default { it, es, en };
